import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/events';

export default function FaqCta() {
  const [open, setOpen] = useState<number | null>(0);
  const teaser = faqs.slice(0, 4);

  return (
    <>
      {/* FAQ 精选 */}
      <section className="bg-background-100/60 border-y border-background-200/70">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <p className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <span className="inline-block w-8 border-t-2 border-primary-500"></span>常见疑问
            </p>
            <h2 className="mt-3 font-display font-black text-foreground-950 text-2xl md:text-3xl">
              关于「看证据说话」
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              第一次来可能好奇我们和普通吃瓜号有何不同。这里用最直接的方式回答你的疑问。
            </p>
            <Link
              to="/faq"
              className="mt-5 inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 text-sm font-medium"
            >
              查看全部 Q&amp;A <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="lg:col-span-8 space-y-3">
            {teaser.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
                >
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full flex items-center gap-3 justify-between px-4 md:px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-medium text-foreground-950 text-sm md:text-base">
                      {f.q}
                    </span>
                    <i
                      className={`ri-${isOpen ? 'subtract' : 'add'}-line text-primary-600 text-lg shrink-0 transition-transform`}
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-3">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* 投稿 CTA */}
      <section className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-2xl bg-background-100 border border-background-200 p-6 md:p-12">
          <div className="pointer-events-none absolute -right-16 -top-16 w-64 h-64 rounded-full bg-primary-100/60 blur-3xl"></div>
          <div className="pointer-events-none absolute -left-10 bottom-0 w-52 h-52 rounded-full bg-accent-100/70 blur-3xl"></div>
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="max-w-2xl">
              <span className="stamp text-xs font-bold px-2 py-0.5">线索征集</span>
              <h2 className="mt-4 font-display font-black text-foreground-950 text-2xl md:text-3xl">
                手上有材料？来对一道证据，别让它烂在私聊里
              </h2>
              <p className="mt-3 text-foreground-600 leading-relaxed text-sm md:text-base">
                如果你掌握可公开核验的线索或遭遇过类似的宣传纠纷，欢迎投稿。
                我们会对敏感信息脱敏、标注来源后再补档，让更多人不被单方面说法带偏。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <Link
                to="/about#contact"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full px-6 py-3 whitespace-nowrap transition-colors"
              >
                <i className="ri-megaphone-line"></i>提交线索
              </Link>
              <Link
                to="/archive?type=audio"
                className="inline-flex items-center justify-center gap-2 border border-background-300 hover:border-accent-300 hover:text-accent-700 bg-background-50 text-foreground-700 font-medium rounded-full px-6 py-3 whitespace-nowrap transition-colors"
              >
                <i className="ri-mic-line"></i>查看录音类档案
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}